<template>
  <v-card class="vercard" flat max-width="378" elevation="0" outlined>

    <div :class="release.artifact.indexOf('INFRA')>=0 ? 'grey':'blue-grey'" class="lighten-5 pr-3 pl-3">

      <v-row align="center"
             justify="center">
        <v-col class="pa-2" :cols="infos[release.zone+'_'+release.artifact] ?8:12">
          <div class="grey--text artifact-def">
            {{ release.artifactDefinition }}
          </div>
          <p :class="release.artifact.indexOf('INFRA')>=0 ? 'grey--text':''" class="display-1 ma-0">
            {{ release.artifact }}
          </p>
          <span class="pt-2" :title="release.completedOn.formatted"><small>{{
              release.completedOn.ago
            }}</small></span>
        </v-col>
        <health-status-area :artifact="release.artifact" :health="health[release.zone+'_'+release.artifact]"
                            :infos="infos[release.zone+'_'+release.artifact]"></health-status-area>
      </v-row>
    </div>

    <v-carousel
      :show-arrows="release.sources.length > 1"
      :show-arrows-on-hover="true"
      height="120"
      dark
      hide-delimiters
      hide-delimiter-background>
      <v-carousel-item v-for="(source, sourceIndex) in release.sources"
                       :key="sourceIndex">
        <v-card-text :class="release.id" class="pb-0">
          <div style="margin-top: -10px" v-if="release.sources.length > 1"
               class="grey--text font-weight-bold">{{ source.alias }}
          </div>
          <v-row>
            <source-area :float-right="true" :source="getPreviousSources(release.id, sourceIndex)"></source-area>
            <v-col class="col-3 pa-1 text-center">
              <v-icon color="grey lighten-2">
                mdi-arrow-right
              </v-icon>
            </v-col>
            <source-area :source="source"></source-area>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-col class="text-left pa-0">
            <v-btn
              text
              color="blue-grey lighten-3"
              @click="getHistory(release,null, source)">
              Show content
            </v-btn>
          </v-col>
          <v-col class="text-right pa-0">
            <v-btn
              v-if="getPreviousSources(release.id, sourceIndex)
              && getPreviousSources(release.id, sourceIndex).commit != source.commit"
              text
              color="blue-grey lighten-1"
              @click="getHistory(release, getPreviousSources(release.id, sourceIndex).commit, source)">
              What's new
            </v-btn>
          </v-col>

        </v-card-actions>
      </v-carousel-item>
    </v-carousel>
    <v-dialog v-model="showHistory" max-width="600px">
      <v-progress-circular v-if="!history"
                           indeterminate
                           color="primary">
      </v-progress-circular>
      <v-card>
        <v-card-title>
          <v-card-title>
            Deployed commits
          </v-card-title>
        </v-card-title>
        <v-card-text v-if="!history">
          Fetching and parsing commits...
        </v-card-text>
        <v-card-text v-if="history">
          <v-list dense>
            <v-list-item-group>
              <v-list-item two-line v-for="commit of history" :key="commit.id">
                <v-list-item-content class="border-bottom">
                  <v-list-item-title v-if="commit.jira">
                    <a :href="`https://jasmin.clasp-infra.com/jira/browse/IT08PEARL-${commit.jira[1]}`"
                       target="_blank">
                      PEARL-{{ commit.jira[1] }}
                    </a>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ commit.comment }}
                    <br/>
                    <small>{{ toDate(commit.author.date) }} <!-- by {{commit.committer.name}} --></small>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>


<script>
import versionService from "@/services/releases";
import SourceArea from "@/views/Releases/SourceArea";
import HealthStatusArea from "@/views/Releases/HealthStatusArea";
import moment from "moment";
import {workersConfig} from '@/store/modules/workers.js'

export default {
  components: {SourceArea, HealthStatusArea},
  name: 'ArtifactCard',
  props: {
    release: {
      type: Object,
      required: true
    },
    infos: {
      type: Object,
      required: true
    },
    health: {
      type: Object,
      required: true
    },
    previous: {
      type: Array,
      required: true
    }
  },
  methods: {
    getHistory: async function (rel, previous, current) {
      this.history = null
      let itemPath = ''
      if (workersConfig.metadata[rel.artifact] && workersConfig.metadata[rel.artifact].sourcePath)
        itemPath = workersConfig.metadata[rel.artifact].sourcePath
      this.showHistory = true
      try {
        this.history = await versionService.getCommits(previous, current, itemPath)
      } catch (error) {
        this.history = ["ERROR HAPPENED: " + error]
      }
    },
    getPreviousSources: function (releaseId, sourceIndex) {
      for (let version of this.previous) {
        if (version.id == releaseId) {
          return version.sources[sourceIndex]
        }
      }
    },
    toDate: function (date) {
      return moment(date).format("DD/MM/YYYY HH:mm")
    }
  },
  data() {
    return {
      showHistory: false,
      history: null,
    }
  }
}
</script>
<style>
.vercard .artifact-def {
  color: #afb9c0 !important;
  text-transform: uppercase;
  font-size: small;
  width: 360px;
}

.vercard.theme--light.v-sheet--outlined {
  border: thin solid #bcbcbc
}


.bad-version {
  color: #ffcd8b;
  font-weight: bold;
}
</style>
